module.exports = __webpack_public_path__ + "static/ai-36b755fe15e2f615b1e36c0ddb5f1cba.jpeg";